import type { NavigationCounts } from '@risksmart-app/trpc/src/types';
import type {
  Appetite_Parent_Bool_Exp,
  GetAppetiteCountQuery,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetAppetiteCountDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { COUNT_STALE_TIME_MS, createQueryHook } from 'src/utils';

import type { NavigationCountArgs } from '../navigation/navigationCounts';
import {
  navigationCountsQueryOptions,
  toAggregate,
} from '../navigation/navigationCounts';

type AppetiteCountArgs = NavigationCountArgs & {
  // The equivalent Hasura bool_exp over appetite_parent drives the GraphQL
  // fallback so the flag-gated twin counts identically.
  where?: Appetite_Parent_Bool_Exp;
};

export const useGetAppetiteCount = createQueryHook<
  AppetiteCountArgs,
  NavigationCounts,
  GetAppetiteCountQuery
>({
  trpcQueryOptions: navigationCountsQueryOptions,
  mapTrpcDataToGraphQL: (data) => ({
    appetite_parent_aggregate: { aggregate: toAggregate(data.appetite) },
  }),
  // Aggregate over a register; mutations invalidate it. See COI-882.
  trpcStaleTime: COUNT_STALE_TIME_MS,
  graphqlDocument: GetAppetiteCountDocument,
  graphqlVariables: (queryArgs) => ({ where: queryArgs?.where }),
});
